import Model from '../../ModelBinding/Model';
import ProductSubtypeCollection from './ProductSubtypeCollection';
import dayjs from 'dayjs';

export default class ProductSubType extends Model {
  static rootUri = 'products/subtypes';

  public code?: string;
  public name?: string;
  public product_type_code?: string;
  public created_by?: string;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public qualification?: string;
  public process_as?:string;
  public rate?:number;
  public boost?: dayjs.Dayjs;

  bind() {
    this.code = this.getStringAttribute('code');
    this.name = this.getStringAttribute('name');
    this.product_type_code = this.getStringAttribute('product_type_code');
    this.created_by = this.getStringAttribute('created_by');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.qualification = this.getStringAttribute('qualification');
    this.process_as = this.getStringAttribute('process_as');
    this.rate = this.getFloatAttribute('rate');
    this.boost = this.getDateAttribute('boost');
  }

  static getCollection() {
    return ProductSubtypeCollection;
  }
}
